/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface WifiScanActionArgs {
  /** List of ssids to scan */
  ssidList: string[];
  /** How long to scan for in ms; 0 is default to 50ms */
  durationMs: number;
}

export interface WifiScanResultData {
}

export interface WifiScanActionStateData {
}

function createBaseWifiScanActionArgs(): WifiScanActionArgs {
  return { ssidList: [], durationMs: 0 };
}

export const WifiScanActionArgs = {
  encode(message: WifiScanActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.ssidList) {
      writer.uint32(10).string(v!);
    }
    if (message.durationMs !== 0) {
      writer.uint32(16).int64(message.durationMs);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WifiScanActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWifiScanActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.ssidList.push(reader.string());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.durationMs = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WifiScanActionArgs {
    return {
      ssidList: globalThis.Array.isArray(object?.ssidList) ? object.ssidList.map((e: any) => globalThis.String(e)) : [],
      durationMs: isSet(object.durationMs) ? globalThis.Number(object.durationMs) : 0,
    };
  },

  toJSON(message: WifiScanActionArgs): unknown {
    const obj: any = {};
    if (message.ssidList?.length) {
      obj.ssidList = message.ssidList;
    }
    if (message.durationMs !== 0) {
      obj.durationMs = Math.round(message.durationMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WifiScanActionArgs>, I>>(base?: I): WifiScanActionArgs {
    return WifiScanActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WifiScanActionArgs>, I>>(object: I): WifiScanActionArgs {
    const message = createBaseWifiScanActionArgs();
    message.ssidList = object.ssidList?.map((e) => e) || [];
    message.durationMs = object.durationMs ?? 0;
    return message;
  },
};

function createBaseWifiScanResultData(): WifiScanResultData {
  return {};
}

export const WifiScanResultData = {
  encode(_: WifiScanResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WifiScanResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWifiScanResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WifiScanResultData {
    return {};
  },

  toJSON(_: WifiScanResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WifiScanResultData>, I>>(base?: I): WifiScanResultData {
    return WifiScanResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WifiScanResultData>, I>>(_: I): WifiScanResultData {
    const message = createBaseWifiScanResultData();
    return message;
  },
};

function createBaseWifiScanActionStateData(): WifiScanActionStateData {
  return {};
}

export const WifiScanActionStateData = {
  encode(_: WifiScanActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WifiScanActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWifiScanActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WifiScanActionStateData {
    return {};
  },

  toJSON(_: WifiScanActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WifiScanActionStateData>, I>>(base?: I): WifiScanActionStateData {
    return WifiScanActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WifiScanActionStateData>, I>>(_: I): WifiScanActionStateData {
    const message = createBaseWifiScanActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
